var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.4545,
    cy: 20,
    rx: 20.4545,
    ry: 20,
    fill: "#CFCED4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6704 11.5296L18.0064 22.1936M10.8711 16.8353L27.477 11.074C28.4996 10.7192 29.4808 11.7004 29.126 12.723L23.3647 29.3289C22.97 30.4665 21.3726 30.4977 20.9338 29.3764L18.2969 22.6376C18.1652 22.3011 17.8989 22.0348 17.5624 21.9031L10.8236 19.2662C9.70229 18.8274 9.73348 17.2299 10.8711 16.8353Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChat);
export default __webpack_public_path__ + "static/media/send_chat.ba4aa3cb821f291e669b850aca6f2f92.svg";
export { ForwardRef as ReactComponent };